module.exports = __webpack_public_path__ + "static/media/financialcrimes.2943e8b3.svg";